import { render } from "./PageProfile.vue?vue&type=template&id=941839fa&scoped=true"
import script from "./PageProfile.vue?vue&type=script&lang=js"
export * from "./PageProfile.vue?vue&type=script&lang=js"

import "./PageProfile.vue?vue&type=style&index=0&id=941839fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-941839fa"]])

export default __exports__